<template>
  <div class="goldWater-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select
        v-model="params.balance"
        placeholder="金币状态"
        size="mini"
        @change="getGoldList('status')"
      >
        <el-option
          v-for="item in glodStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        placeholder="请输入用户ID"
        size="small"
        clearable
        class="param-input"
        v-model="params.uid"
      >
      </el-input>
      <el-select
        v-model="params.tranType"
        clearable
        placeholder="请选择用途"
        size="mini"
        @change="getGoldList('status')"
      >
        <el-option
          v-for="(item, index) in useOption"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-input
        placeholder="请输入渠道码"
        size="small"
        clearable
        class="param-input"
        v-model="params.districtCode"
      >
      </el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getGoldList()"
        >搜索</el-button
      >
      <el-button type="primary" size="small" @click="exportdata"
        >导出</el-button
      >
    </div>
    <!--表格数据-->
    <el-table
      height="620"
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column prop="id" label="ID" align="center"></el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金币数量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="tranType"
        label="用途"
        align="center"
      ></el-table-column>
<!--      <el-table-column-->
<!--        prop="money"-->
<!--        label="游戏金币"-->
<!--        align="center"-->
<!--      ></el-table-column>-->
      <el-table-column
        prop="realAmount"
        label="用户余额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="desc"
        label="描述"
        align="center"
        width="300"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import {changeSumDate, changeTime, paramsFilter} from "@/utils/global";
// import moment from "moment";
import API from "@/api";

export default {
  data() {
    return {
      glodStatus: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "收入",
          value: 1,
        },
        {
          label: "支出",
          value: 2,
        },
      ],
      loading: false,
      time: "",
      total: 0,
      tableData: [],
      useOption: [],
      params: {
        pageNumber: 1,
        pageSize: 20,
        uid: "",
        tranType: "",
        balance: 0,
        start: "",
        end: "",
      },
    };
  },
  computed: {
    timeDefault() {
      let date = new Date();
      // 通过时间戳计算
      let defalutStartTime = changeTime(date.getTime()); // 转化为时间戳
      let defalutEndTime = changeTime(date.getTime());
      let startDateNs = new Date(defalutStartTime);
      let endDateNs = new Date(defalutEndTime);
      // 月，日 不够10补0
      defalutStartTime = changeSumDate(
        startDateNs.getFullYear() +
          "-" +
          (startDateNs.getMonth() + 1) +
          "-" +
          (startDateNs.getDate() - 1)
      );
      defalutEndTime = changeSumDate(
        endDateNs.getFullYear() +
          "-" +
          (endDateNs.getMonth() + 1) +
          "-" +
          (endDateNs.getDate() + 1)
      );
      return [defalutStartTime, defalutEndTime];
    },
  },
  created() {
    // let date = new Date()
    // let defalutStartTime2 = (date.getTime()) // 转化为时间戳
    // let defalutEndTime2 = date.getTime()
    // let startDateNs2 = new Date(defalutStartTime2)
    // //  let endDateNs = new Date(defalutEndTime)
    // defalutStartTime2 =changeSumDatejb(startDateNs2.getFullYear() +
    //   '-' +
    //   (startDateNs2.getMonth() + 1) +
    //   '-' +
    //   (startDateNs2.getDate()))

    // defalutEndTime2 = changeSumDatejb(startDateNs2.getFullYear() +
    //   '-' +
    //   (startDateNs2.getMonth() + 1) +
    //   '-' +
    //   (startDateNs2.getDate() +1))

    this.time = this.getTodayAndTomorrow();

    this.params.start = this.getTodayAndTomorrow()[0];
    this.params.end = this.getTodayAndTomorrow()[1];
    this.getGoldList();
  },
  mounted() {
    this.getUseList();
  },
  methods: {
    getTodayAndTomorrow() {
      // 获取当前日期时间
      const today = new Date();

      // 获取明天日期时间（当前日期加1天）
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      // 格式化日期为 YYYY-MM-DD HH:mm:ss
      function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }

      return [formatDate(today), formatDate(tomorrow)];
    },
    getGoldList(type) {
      this.loading = true;
      if (type) {
        this.params.pageNumber = 1;
      }
      API.getGlodList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.logs) {
            this.tableData = res.data.logs;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //获取用途
    getUseList() {
      API.getUseList()
        .then((res) => {
          if (res.code === 200) {
            this.useOption = res.data.list;
          } else {
            this.useOption = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 导出数据
    exportdata() {
      let params = paramsFilter(this.params);
      let str = "";
      for (let key in params) {
        if (key == "start" || key == "end") {
          params[key] = params[key].replace("+", "%2B");
        }
        str += key + "=" + params[key] + "&";
      }
      str = str.substring(0, str.length - 1);
      let url = baseConfig.baseServerUrl + "/export/goldTurnover?" + str;
      window.location.href = url;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getGoldList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getGoldList();
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.start = changeTime(time[0]) || "";
        this.params.end = changeTime(time[1]) || "";
      } else {
        this.params.start = "";
        this.params.end = "";
      }
      this.getGoldList("status");
    },
  },
};
</script>
